<template>
  <v-sheet class="iframe-wrapper">
    <iframe :src="src" frameborder="0" class="iframe-content"></iframe>
  </v-sheet>
</template>

<script>
import { computed, unref } from "vue";
import { addUrlParams } from "../common/helpers/datastudio";
import useFacility from "../authentication/useFacility";

export default {
  name: "UnitMissedDevices",
  setup() {
    const { currentFacility } = useFacility();

    const src = computed(() => {
      const facility = unref(currentFacility);
      return addUrlParams(
        import.meta.env.VUE_APP_EMBEDDED_UNIT_MISSED_DEVICE_REPORT_URL,
        {
          id: facility.id,
        }
      );
    });

    return { src };
  },
};
</script>

<style scoped>
.iframe-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}

.iframe-content {
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 1600px;
  min-height: 800px;
  flex-grow: 1;
}
</style>
